import React from 'react';
import { Card, CardContent } from './ui/card';
import { Avatar, AvatarImage, AvatarFallback } from './ui/avatar';
import { Quote, Award } from 'lucide-react';
import { mockTestimonials } from '../mock';

const Testimonials = ({ t, currentLang }) => {
  const getTestimonialText = (testimonial) => {
    if (currentLang === 'de') return testimonial.textDe;
    if (currentLang === 'sq') return testimonial.textSq;
    return testimonial.text;
  };

  return (
    <section id="testimonials" className="relative py-24 px-4 bg-gradient-to-br from-slate-50 via-white to-emerald-50/30 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-br from-red-200/25 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-gradient-to-tl from-orange-200/20 to-transparent rounded-full blur-3xl"></div>
        
        {/* Subtle pattern */}
        <div className="absolute inset-0 opacity-[0.015]" style={{
          backgroundImage: 'radial-gradient(circle at 3px 3px, rgb(220, 38, 38) 2px, transparent 0)',
          backgroundSize: '60px 60px'
        }}></div>
      </div>
      <div className="container mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-red-950/50 text-orange-400 rounded-full text-sm font-semibold mb-4 border border-red-900/30">
            {t.nav.testimonials}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {t.testimonials.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Real success stories from Albanian workers in Germany
          </p>
        </div>

        {/* Testimonials Grid - Show all 12 */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTestimonials.map((testimonial) => (
            <Card key={testimonial.id} className="border border-slate-200 shadow-lg hover:shadow-xl transition-all duration-300 relative overflow-hidden bg-white">
              {/* Quote Icon Background */}
              <div className="absolute top-4 right-4 opacity-10">
                <Quote className="h-24 w-24 text-red-600" />
              </div>
              
              <CardContent className="p-8 relative z-10">
                <div className="flex items-center gap-4 mb-6">
                  <Avatar className="h-16 w-16 border-2 border-red-200">
                    <AvatarFallback className="bg-red-100 text-red-700 font-semibold text-lg">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <div className="font-bold text-slate-900">{testimonial.name}</div>
                    <div className="text-sm text-slate-600">{testimonial.position}</div>
                    <div className="text-sm text-orange-600">{testimonial.location}</div>
                    <div className="text-xs text-gray-500 mt-1">Since {testimonial.year}</div>
                  </div>
                </div>
                
                <p className="text-slate-600 leading-relaxed italic text-sm">
                  "{getTestimonialText(testimonial)}"
                </p>

                {/* Rating Stars */}
                <div className="flex gap-1 mt-6">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
